import { Target, Search, ShieldCheck, MessageSquare, BarChart2, Moon, Sun, Zap } from 'lucide-react';
import { useApp } from '../context/AppContext';

const NAV = [
  { id: 'hunt', icon: Search, label: 'Hunt' },
  { id: 'qualify', icon: ShieldCheck, label: 'Qualify' },
  { id: 'pitches', icon: MessageSquare, label: 'Scripts' },
  { id: 'ai', icon: Zap, label: 'AI Pitch' },
  { id: 'tracker', icon: Target, label: 'Tracker' },
  { id: 'analytics', icon: BarChart2, label: 'Analytics' },
];

export default function Sidebar({ active, setActive }) {
  const { theme, toggleTheme } = useApp();
  return (
    <aside style={{
      width: 220, minHeight: '100vh', background: 'var(--bg2)',
      borderRight: '1px solid var(--border)',
      display: 'flex', flexDirection: 'column',
      position: 'fixed', top: 0, left: 0, zIndex: 100,
    }}>
      <div style={{ padding: '1.5rem 1.25rem 1rem', borderBottom: '1px solid var(--border)' }}>
        <div style={{ display: 'flex', alignItems: 'center', gap: 10 }}>
          <div style={{ width: 32, height: 32, borderRadius: 8, background: 'var(--accent)', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
            <Zap size={16} color="#000" fill="#000" />
          </div>
          <div>
            <div style={{ fontFamily: 'var(--font-display)', fontWeight: 800, fontSize: 16, color: 'var(--text)', letterSpacing: '-0.02em' }}>W3Pitch</div>
            <div style={{ fontSize: 10, color: 'var(--text3)', fontFamily: 'var(--font-mono)' }}>Web3 Hunting Kit</div>
          </div>
        </div>
      </div>
      <nav style={{ flex: 1, padding: '0.75rem' }}>
        {NAV.map(({ id, icon: Icon, label }) => {
          const isActive = active === id;
          return (
            <button key={id} onClick={() => setActive(id)} style={{
              display: 'flex', alignItems: 'center', gap: 10,
              width: '100%', padding: '10px 12px', borderRadius: 'var(--radius)',
              border: 'none', textAlign: 'left', marginBottom: 2,
              background: isActive ? 'var(--accent-dim)' : 'transparent',
              color: isActive ? 'var(--accent)' : 'var(--text2)',
              fontSize: 14, fontWeight: isActive ? 500 : 400, transition: 'all 0.15s',
            }}
            onMouseEnter={e => !isActive && (e.currentTarget.style.background = 'var(--surface)')}
            onMouseLeave={e => !isActive && (e.currentTarget.style.background = 'transparent')}
            >
              <Icon size={16} />
              {label}
              {id === 'ai' && <span style={{ marginLeft: 'auto', fontSize: 9, fontFamily: 'var(--font-mono)', background: 'var(--accent-dim)', color: 'var(--accent)', padding: '2px 6px', borderRadius: 10 }}>AI</span>}
            </button>
          );
        })}
      </nav>
      <div style={{ padding: '1rem', borderTop: '1px solid var(--border)' }}>
        <button onClick={toggleTheme} style={{
          display: 'flex', alignItems: 'center', gap: 8,
          background: 'transparent', border: '1px solid var(--border2)',
          borderRadius: 'var(--radius)', padding: '8px 12px',
          color: 'var(--text2)', fontSize: 13, width: '100%', transition: 'all 0.15s',
        }}>
          {theme === 'dark' ? <Sun size={14} /> : <Moon size={14} />}
          {theme === 'dark' ? 'Light mode' : 'Dark mode'}
        </button>
      </div>
    </aside>
  );
}
